import React from 'react';
import { Flex, Heading, Box, Text, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon, } from '@spothero/ui';
import Price from 'common/price';
const TotalPriceBreakdownItem = ({ item, currencyType, }) => {
    return (<Flex justifyContent="space-between" marginY={2}>
            {item.full_description ? (<AccordionItem border="none">
                    <Heading as="h2" fontFamily="body">
                        <AccordionButton paddingX={0} paddingY={0} gridGap={1} border="none" _hover={{
                backgroundColor: 'none',
            }} sx={{
                '.chakra-accordion__icon': {
                    color: 'black',
                },
            }}>
                            <Box textAlign="left" fontWeight="normal">
                                <Text fontSize="sm">
                                    {item.short_description}
                                </Text>
                            </Box>
                            <AccordionIcon fontSize="xl"/>
                        </AccordionButton>
                    </Heading>
                    <AccordionPanel paddingX={0} paddingTop={0} paddingBottom={1} color="gray.dark" fontSize="xs">
                        {item.full_description}
                    </AccordionPanel>
                </AccordionItem>) : (<Text fontSize="sm">{item.short_description}</Text>)}
            <Price amount={item.price} currencyType={currencyType} showCents/>
        </Flex>);
};
export default TotalPriceBreakdownItem;
